import React from 'react';

const RemarksSection = ({
  classTeacherRemarks = '',
  principalRemarks = '',
  showTeacherRemarks = true,
  showPrincipalRemarks = true,
  primaryColor = '#1e3a8a'
}) => {
  if (!showTeacherRemarks && !showPrincipalRemarks) {
    return null;
  }

  return (
    <div style={{
      marginBottom: '18px',
      display: 'grid',
      gridTemplateColumns: (showTeacherRemarks && showPrincipalRemarks) ? '1fr 1fr' : '1fr',
      gap: '14px',
      fontSize: '10.5px'
    }}>
      {showTeacherRemarks && (
        <div style={{ border: '1px solid #cbd5e1', borderRadius: '6px', padding: '8px 12px', background: '#f8fafc' }}>
          <strong style={{ color: primaryColor, display: 'block', marginBottom: '4px', textTransform: 'uppercase' }}>Class Teacher Remarks:</strong>
          <span style={{ fontStyle: classTeacherRemarks ? 'normal' : 'italic', color: classTeacherRemarks ? '#0f172a' : '#94a3b8' }}>
            {classTeacherRemarks || 'No remarks recorded yet.'}
          </span>
        </div>
      )}
      {showPrincipalRemarks && (
        <div style={{ border: '1px solid #cbd5e1', borderRadius: '6px', padding: '8px 12px', background: '#f8fafc' }}>
          <strong style={{ color: primaryColor, display: 'block', marginBottom: '4px', textTransform: 'uppercase' }}>Principal Observation:</strong>
          <span style={{ fontStyle: principalRemarks ? 'normal' : 'italic', color: principalRemarks ? '#0f172a' : '#94a3b8' }}>
            {principalRemarks || 'No observation recorded yet.'}
          </span>
        </div>
      )}
    </div>
  );
};

export default RemarksSection;
